import reducer from 'state/mrCollection/extras/reducer';
import actions from 'state/mrCollection/extras/actionCreators';

export { actions };

export default reducer;
